export default __webpack_public_path__ + "static/media/img6.a45f1693.png";